import React from "react";
import { useParams } from "react-router-dom";
import jobs from "../data/jobs";
import styles from "./JobDetails.module.css";
import CustomButton from "../components/CustomButton";
import BackToTop from "../components/BackToTop";

const JobDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const job = jobs.find((j) => j.id === id);

  if (!job) {
    return (
      <main className={styles.jobDetailsPage}>
        <div className={styles.inner}>
          <div className={styles.jobCard}>
            <h2 className={styles.notFound}>Stelle nicht gefunden</h2>
            <div className={styles.buttonWrapper}>
              <CustomButton
                text="← Zurück zur Übersicht"
                to="/jobs"
                variant="outline"
                size="small"
              />
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className={styles.jobDetailsPage}>
      <div className={styles.inner}>
        <section className={styles.jobCard}>
          <h1 className={styles.title}>{job.title}</h1>
          <p className={styles.location}>{job.location}</p>

          <div className={styles.sectionBlock}>
            <h3>Das erwartet Sie</h3>
            <ul>
              {job.responsibilities.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div className={styles.sectionBlock}>
            <h3>Das wünschen wir uns</h3>
            <ul>
              {job.requirements.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div className={styles.sectionBlock}>
            <h3>Das bieten wir Ihnen</h3>
            <ul>
              {job.benefits.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div className={styles.contact}>
        <p className={styles.bezeichnung}>
         
              * Die Stellenbezeichnung gilt für alle Geschlechter gleichermaßen.
            </p>

            <p>
           
              Wenn wir Ihr Interesse geweckt haben, freuen wir uns auf Ihre
              aussagekräftigen Bewerbungsunterlagen unter Angabe Ihrer
              Gehaltsvorstellung und Ihres frühestmöglichen Eintrittstermins,
              ausschließlich per E-Mail (bitte im PDF-Format, max. 20 MB) an:
            </p>
            <a
              href="mailto:bewerbung@avila-gruppe.de"
              className={styles.emailLink}
            >
              bewerbung@avila-gruppe.de
            </a>
          </div>

          <div className={styles.buttonWrapper}>
            <CustomButton
              text="Zurück zur Übersicht"
              to="/jobs"
              variant="outline"
              size="medium"
            />
          </div>
        </section>
      </div>
    </main>
  );
};

export default JobDetails;
